<script>
import _map from 'lodash/map'
import { allowedInvoicePayment } from '@/stores/basket'
import { banks, selectedBankId, setSelectedBankId } from '@/stores/banks'
import { computed, toRaw, ref } from 'vue'
import __ from '@/helper/translation'
import { productsTotalVatPrice } from '@/stores/product'
import { transportTotalVatPrice } from '@/stores/transport'

const paymentInfoById = {
  'montonio_v2|bnpl': {
    title: 'Inbank maksa hiljem',
    content: `
      <p>Inbanki makseviisid aitavad ostude eest veelgi mugavamalt tasuda. Tasu oma ostu eest alles järgmisel kuul või jaga ostusumma mitmeks võrdseks osaks, lihtsalt ja ilma ühegi lisatasuta.</p>
      <p>Leia sobiv makselahendus kassast ja vali endale sobivaim järgmistest valikutest.</p>
      <p><strong>Inbank maksa järgmisel kuul</strong></p>
      <ul>
        <li>Maksa 30 päeva pärast ostu sooritamist</li>
        <li>30 – 800 € ostudele</li>
        <li>0 € lisatasu</li>
      </ul>
      <p><strong>Inbank jaga osadeks</strong></p>
      <ul>
        <li>75 – 2500 € ostudele</li>
        <li>Periood 2 või 3 kuud</li>
        <li>0 € lisatasu</li>
      </ul>
      <p><strong>Miks valida Inbanki makseviis?</strong></p>
      <ul>
        <li>Lihtne ja lisatasudeta - pole intressi, lepingutasu ega igakuist haldustasu.</li>
        <li>Nutikas viis soetada kohe kõik, mida vajad, tegemata valikute arvelt järeleandmisi.</li>
        <li>Inbanki maksa hiljem makseviisi puhul ei ole tegu järelmaksuga, vaid krediidivaba makseviisiga – see ei mõjuta sinu krediidiskoori.</li>
      </ul>
      <p>Inbanki makseviisiga tasumine on lihtne!</p>
    `,
  },
  'montonio_v2|hirePurchase': {
    title: 'Inbank järelmaks',
    content: `
      <p>Inbanki järelmaks võimaldab sul muuta suur ühekordne väljaminek igakuiseks väikeseks kuluks ning tasuda toodete ja teenuste eest osade kaupa. Võta maksmiseks rohkem aega ning jaga ostusumma kuni 6 aasta peale. Esimene makse alles kuu aja pärast.</p>
      <p><strong>Inbanki järelmaksu eelised:</strong></p>
      <ul>
        <li>Paindlik lahendus suuremateks väljaminekuteks</li>
        <li>Sina valid järelmaksu summa suuruse</li>
        <li>Sina valid järelmaksu perioodi</li>
        <li>Sina valid maksekuupäeva</li>
        <li>Vastus taotlusele minutiga</li>
      </ul>
      <p><strong>Inbanki järelmaksu tingimused:</strong></p>
      <ul>
        <li>Summa 100 - 5000 €</li>
        <li>Periood 3 - 72 kuud</li>
        <li>Sissemakse 0 €</li>
        <li>Intress 11,9%</li>
        <li>Lepingutasu 0 €</li>
        <li>Haldustasu 0,3% kuus</li>
      </ul>
    `,
  },
}

export default {
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    if (transportTotalVatPrice.value + productsTotalVatPrice.value === 0.0) {
      setSelectedBankId('invoice')
    } else {
      setSelectedBankId(banks.value[0].id)
    }
    const bankList = computed(() => {
      if (transportTotalVatPrice.value + productsTotalVatPrice.value === 0) {
        return []
      }

      const collectBanks = _map(banks.value, (bank) => {
        bank = toRaw(bank)
        bank.selected = bank.id === selectedBankId.value
        bank.images = []
        if (bank.id === 'lhv') {
          bank.images = [
            {
              name: 'LHV',
              url: './ui/template/rallyestonia/images/bank/basket/lhv.svg',
            },
          ]
        }
        if (bank.id === 'montonio_v2|bnpl') {
          bank.images = [
            {
              name: 'Montonio Split',
              url: './ui/template/rallyestonia/images/bank/basket/rewrc_inbank_intress.svg',
            },
          ]
        }
        if (bank.id === 'montonio_v2|hirePurchase') {
          bank.images = [
            {
              name: 'Montonio Järelmaks',
              url: './ui/template/rallyestonia/images/bank/basket/rewrc_inbank_jarelmaks.svg',
            },
          ]
        }
        if (bank.id === 'lhv_paytech') {
          bank.images = [
            {
              name: 'Visa',
              url: './ui/template/rallyestonia/images/bank/basket/visa.svg',
            },
            {
              name: 'LHV',
              url: './ui/template/rallyestonia/images/bank/basket/lhv.svg',
            },
            {
              name: 'Swedbank',
              url: './ui/template/rallyestonia/images/bank/basket/swedbank_eesti.svg',
            },
            {
              name: 'SEB',
              url: './ui/template/rallyestonia/images/bank/basket/seb_eesti.svg',
            },
          ]
        }

        if (bank.id === 'everypay_v3') {
          bank.images = [
            {
              name: 'Visa',
              url: './ui/template/rallyestonia/images/bank/basket/visa.svg',
            },
            {
              name: 'Swedbank',
              url: './ui/template/rallyestonia/images/bank/basket/swedbank_eesti.svg',
            },
            {
              name: 'SEB',
              url: './ui/template/rallyestonia/images/bank/basket/seb_eesti.svg',
            },
            {
              name: 'Coop',
              url: './ui/template/rallyestonia/images/bank/basket/coop_pank.svg',
            },
          ]
        }
        return bank
      })

      if (allowedInvoicePayment.value) {
        collectBanks.push({
          name: __('invoice_payment_label'),
          id: 'invoice',
          images: [],
          selected: 'invoice' === selectedBankId.value,
        })
      }

      return collectBanks
    })

    const openInfoBankId = ref(null)
    const currentPaymentInfo = computed(() => paymentInfoById[openInfoBankId.value] || null)
    const hasPaymentInfo = (bankId) => Boolean(paymentInfoById[bankId])
    const openPaymentInfo = (bankId) => { openInfoBankId.value = bankId }
    const closePaymentInfo = () => { openInfoBankId.value = null }

    return {
      bankList,
      setSelectedBankId,
      openInfoBankId,
      currentPaymentInfo,
      hasPaymentInfo,
      openPaymentInfo,
      closePaymentInfo,
    }
  },
}
</script>

<template>
  <div class="mb-10" v-if="bankList.length">
    <h3 class="text-uppercase mb-14 font-black text-black">
      {{ __('payment_title') }}
    </h3>

    <div class="-m-4 mb-1 flex flex-col items-start">
      <div class="p-4" v-for="option in bankList" :key="`cf${option.id}`">
        <label class="custom-radio" :class="option.id">
          <span class="payment-option-content flex w-full flex-1 flex-wrap items-center" v-if="option.images && option.images.length">
            <span class="-m-2.5 flex flex-wrap items-center">
              <img
                class="m-2.5"
                v-for="image in option.images"
                :key="`oi${image.url}`"
                :src="image.url"
                :alt="image.name"
                :class="(option.id === 'lhv' || option.id === 'lhv_paytech') ? 'icon-big' : 'icon'"
              />
            </span>
            <button
              v-if="hasPaymentInfo(option.id)"
              class="info-button"
              type="button"
              @click.stop.prevent="openPaymentInfo(option.id)"
              aria-label="Makseviisi info"
            >
              i
            </button>
          </span>

          <span v-else>
            <span class="payment-option-content">{{ option.name }}</span>
            <button
              v-if="hasPaymentInfo(option.id)"
              class="info-button"
              type="button"
              @click.stop.prevent="openPaymentInfo(option.id)"
              aria-label="Makseviisi info"
            >
              i
            </button>
          </span>

          <input
            :id="option.id"
            :value="option.id"
            type="radio"
            :checked="option.selected"
            @change="setSelectedBankId(option.id)"
          />
          <span class="border border-black"></span>
        </label>

      </div>

        <teleport to="body">
          <transition name="tw-custom-fade" mode="out-in" enterActiveClass="transition-opacity duration-300" enterFromClass="opacity-0" leaveActiveClass="transition-opacity duration-300" leaveToClass="opacity-0">
            <div v-if="currentPaymentInfo">
              <div class="fixed inset-0 overflow-y-auto z-101">
                <div class="flex min-h-full items-center justify-center p-[1.6rem]">
                  <div class="payment-info-modal bg-white p-12">
                    <div class="flex items-start justify-between mb-4">
                      <h3 class="text-lg font-semibold">{{ currentPaymentInfo.title }}</h3>
                      <button class="payment-info-close" aria-label="Sulge makseviisi info" @click="closePaymentInfo">×</button>
                    </div>
                    <div class="payment-info-content" v-html="currentPaymentInfo.content"></div>
                  </div>
                </div>
              </div>
              <div class="z-100 fixed inset-0 bg-black bg-opacity-70" @click="closePaymentInfo"></div>
            </div>
          </transition>
        </teleport>

    </div>
  </div>
</template>

<style lang="scss" scoped>
.icon {
  height: 3.5rem !important;
}

.icon-big {
  height: 5rem !important;
}

.custom-radio.lhv input + span, .custom-radio.lhv_paytech input + span {
  top: 50%;
  transform: translateY(-50%);
}

.payment-option-content {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.info-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid #000;
  border-radius: 9999px;
  background: #fff;
  color: #000;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.payment-info-modal {
  width: min(100%, 64rem);
}

.payment-info-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  padding: 0;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.payment-info-content {
  :deep(p) {
    font-size: 1.6rem;
    margin: 0 0 1.6rem;
  }

  :deep(ul) {
    margin: 0 0 1.6rem;
    padding-left: 1.8rem;
    list-style: disc;
  }

  :deep(li) {
    margin-bottom: 0.8rem;
    font-size: 1.6rem;
  }
}
</style>
